import React from "react";
import { User, Mail, Trophy } from "lucide-react";

const DashboardHeader = ({ candidate }) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg p-6 text-white">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="bg-white/20 rounded-full p-3">
            <User className="h-8 w-8" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">Welcome back, {candidate.name}</h1>
            <p className="text-blue-100">Ready to take your assessments?</p>
          </div>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-white/10 rounded-lg p-3">
          <div className="flex items-center space-x-2">
            <Mail className="h-4 w-4" />
            <span className="text-sm">{candidate.email}</span>
          </div>
        </div>
        <div className="bg-white/10 rounded-lg p-3">
          <div className="flex items-center space-x-2">
            <Trophy className="h-4 w-4" />
            <span className="text-sm">Status: {candidate.status}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;